var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 f-c-c f-d-c"},[(_vm.isLoader)?_c('b-spinner',{staticClass:"mb-3",attrs:{"variant":"primary","type":"grow","label":"Spinning"}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }